import React, { useState, useEffect } from "react";
import BackBtn from "../../common/backBTN";

const Inbox = () => {
  const [inboxMessages, setInboxMessages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [fullMessage, setFullMessage] = useState(null);
  const [activeTab, setActiveTab] = useState("inbox");
  const isLoggedIn = !!localStorage.getItem("token");
  const [selectedMessages, setSelectedMessages] = useState([]);


  // === Fetch Inbox Messages ===
  const fetchInboxMessages = async () => {
    const token = localStorage.getItem("token");
    const remoteId = localStorage.getItem("remote_id");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/inbox?remote_id=${remoteId}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();
      if (data.success && data.data) {
        setInboxMessages(data.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching inbox messages:", error);
    }
  };

  // === Fetch Full Message ===
  const fetchFullMessage = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/inbox/${id}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = await response.json();
      if (data.success) {
        setFullMessage(data.data);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching full message:", error);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchInboxMessages();
    }
  }, [isLoggedIn]);

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <section className="webMail" style={{ height: "100%", background: "#fff" }}>
        {/* === Header === */}
        <header className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-profitandloss am-navbar am-navbar-light mc-default-header"
          >
            <BackBtn />
            <div className="am-navbar-title">Internal Message</div>
            <div className="am-navbar-right" />
          </div>
        </header>

        {/* === Tabs === */}
        <div className="am-tabs am-tabs-top">
          <div role="tablist" className="am-tabs-bar" tabIndex={0}>
            <div
              role="tab"
              aria-selected={activeTab === "inbox"}
              className={`am-tabs-tab ${
                activeTab === "inbox" ? "am-tabs-tab-active" : ""
              }`}
              onClick={() => setActiveTab("inbox")}
            >
              <div className="EmailMessage">
                <i />
                Inbox
              </div>
            </div>
            <div
              role="tab"
              aria-selected={activeTab === "outbox"}
              className={`am-tabs-tab ${
                activeTab === "outbox" ? "am-tabs-tab-active" : ""
              }`}
              onClick={() => setActiveTab("outbox")}
            >
              <div className="EmailMessage">
                <i />
                Outbox
              </div>
            </div>
          </div>

          {/* === Inbox === */}
          {activeTab === "inbox" && (
            <div
              role="tabpanel"
              aria-hidden="false"
              className="am-tabs-tabpane am-tabs-tabpane-active"
            >
              <div className="getMail">
                <div className="getDit">
                  <div className="status">
                    <span className="all">
                      <label className="am-checkbox-wrapper">
                        <span className="am-checkbox">
                          <input type="checkbox" className="am-checkbox-input" />
                          <span className="am-checkbox-inner" />
                        </span>
                        Select all
                      </label>
                    </span>
                    <div className="right-com">
                      <span className="label-read">
                        <svg className="am-icon am-icon-mail-read_c8afd723 am-icon-md">
                          <use xlinkHref="#mail-read_c8afd723" />
                        </svg>
                      </span>
                      <span className="del">
                        <svg className="am-icon am-icon-mail-delete_49fd10ef am-icon-md delete-icon">
                          <use xlinkHref="#mail-delete_49fd10ef" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="EmailList">
                  <div
                    className="list-wrapper"
                    style={{
                      height: "calc(100 * var(--vh, 1vh) - 139.45px)",
                    }}
                  >
                    {inboxMessages.length > 0 ? (
                      <ul
                        className="scroll-inner-container"
                        style={{
                          transitionTimingFunction:
                            "cubic-bezier(0.165, 0.84, 0.44, 1)",
                          transitionDuration: "0ms",
                        }}
                      >
                        {inboxMessages.map((msg) => (
                          <li key={msg.id} onClick={() => fetchFullMessage(msg.id)}>
                            <div className="EmaiWebList">
                              <div className="am-flexbox am-flexbox-align-middle">
                                <div className="am-flexbox-item">
                                  <div
                                    data-seed="logId"
                                    className="am-checkbox-agree"
                                  >
                                    <label className="am-checkbox-agree-label am-checkbox-wrapper">
                                      <span className="am-checkbox">
                                        <input
                                          type="checkbox"
                                          className="am-checkbox-input"
                                          data-seed="logId"
                                          value="on"
                                        checked={selectedMessages.includes(msg.id)}
                                        onChange={() =>
                                          setSelectedMessages((prev) =>
                                            prev.includes(msg.id)
                                              ? prev.filter((id) => id !== msg.id)
                                              : [...prev, msg.id]
                                          )
                                        }
                                        />
                                        <span className="am-checkbox-inner" />
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="mail-info">
                                <div className="am-list-item am-list-item-top">
                                  <div className="am-list-thumb">
                                    {!msg.is_read && (
                                      <span className="look am-badge am-badge-not-a-wrapper">
                                        <sup className="am-badge-dot" />
                                      </span>
                                    )}
                                  </div>
                                  <div className="am-list-line am-list-line-multiple">
                                    <div className="am-list-content">
                                      Sender: {msg.sender || "Platform"}
                                    </div>
                                    <div className="am-list-extra">
                                      {msg.created_at
                                        ? msg.created_at
                                            .slice(0, 19)
                                            .replace("T", " ")
                                        : ""}
                                    </div>
                                    <div
                                      className="am-list-arrow am-list-arrow-horizontal"
                                      aria-hidden="true"
                                    />
                                  </div>
                                </div>
                                <div className="am-list-brief">
                                  Title: {msg.title || "Untitled"}
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div
                        className="nodata-container"
                        style={{
                          textAlign: "center",
                          paddingTop: "4rem",
                          height: "100%",
                        }}
                      >
                        <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                          <use xlinkHref="#nodata_f4c19c2d" />
                        </svg>
                        <p>No messages</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* === Outbox === */}
          {activeTab === "outbox" && (
            <div
              role="tabpanel"
              aria-hidden="false"
              className="am-tabs-tabpane am-tabs-tabpane-active"
            >
              <div className="getMail">
                <div className="EmailList">
                  <div
                    className="nodata-container"
                    style={{
                      textAlign: "center",
                      paddingTop: "4rem",
                      height: "calc(100 * var(--vh, 1vh) - 140px)",
                    }}
                  >
                    <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                      <use xlinkHref="#nodata_f4c19c2d" />
                    </svg>
                    <p>No outgoing messages</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* === Popup === */}
      {showModal && fullMessage && (
        <div data-reactroot>
          <div className="am-popup-mask" onClick={() => setShowModal(false)} />
          <div
            tabIndex={-1}
            className="am-popup-wrap mc-email-popup"
            role="dialog"
          >
            <div role="document" className="am-popup am-popup-slide-up">
              <div className="am-popup-content">
                <button
                  aria-label="Close"
                  className="am-popup-close"
                  onClick={() => setShowModal(false)}
                >
                  <span className="am-popup-close-x" />
                </button>

                <div className="am-popup-body">
                  <div id="root" className="email-detail-container shell_root">
                    <header className="mc-header-wrap">
                      <div
                        id="mc-header"
                        className="mc-navbar-blue mc-default-header am-navbar am-navbar-light"
                      >
                        <div
                          className="am-navbar-left"
                          role="button"
                          onClick={() => setShowModal(false)}
                        >
                          <span className="am-navbar-left-content">
                            <span className="return_icon">
                              <svg className="am-icon am-icon-left am-icon-lg">
                                <use xlinkHref="#left" />
                              </svg>
                            </span>
                          </span>
                        </div>
                        <div className="am-navbar-title">{fullMessage.title}</div>
                      </div>
                    </header>

                    <div className="email-detail">
                      <div className="am-list emailMessageInset">
                        <div className="am-list-body">
                          <div className="message-open-title am-list-item am-list-item-middle">
                            <div className="am-list-line">
                              <div className="am-list-content">Sender:</div>
                              <div className="am-list-extra">
                                {fullMessage.sender || "Platform"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="emailMessageInset"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "0.3rem",
                        }}
                      >
                        <span>Time:</span>
                        <span>
                          {fullMessage.created_at
                            ? fullMessage.created_at
                                .slice(0, 19)
                                .replace("T", " ")
                            : ""}
                        </span>
                      </div>

                      <div className="am-list emailMessageInsetContent">
                        <div className="am-list-body">
                          <div className="am-list-item am-list-item-top">
                            <div className="am-list-line am-list-line-wrap">
                              <div
                                className="am-list-content wysiwyg"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    fullMessage.message ||
                                    "<p>No message content</p>",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div tabIndex={0} style={{ width: 0, height: 0, overflow: "hidden" }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Inbox;
